module.exports = __webpack_public_path__ + "img/service-1.5cf55654.jpg";